import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PaymentRequestSendSmsRequest } from '@payer-admin-ui/api/src/paymentrequests/requests/PaymentRequestSendSmsRequest';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { paymentRequestAPI } from '../../../redux/paymentRequestAPI';

export const sendPaymentRequest = createAsyncThunk<void, { id: string; requestBody: PaymentRequestSendSmsRequest }>(
  'paymentrequests/SendPaymentRequestActions/send',
  async ({ id, requestBody }) => {
    return paymentRequestAPI.sendPaymentRequest({ id, body: requestBody });
  },
);

export type SendPaymentRequestState = {
  [id: string]: FetchingState | undefined;
};

const sendPaymentRequestActionsSlice = createSlice({
  name: 'sendPaymentRequestActions',
  initialState: {} as SendPaymentRequestState,
  reducers: {
    resetSingleSendPaymentRequestError: (state, { payload: { id } }) => {
      delete state[id]?.error;
    },
    resetSingleSendPaymentRequestSuccess: (state, { payload: { id } }) => {
      delete state[id]?.success;
    },
  },
  extraReducers: builder => {
    builder.addCase(sendPaymentRequest.pending, (state, { meta: { arg } }) => {
      state[arg.id] = { isFetching: true, success: undefined, error: undefined };
    });
    builder.addCase(sendPaymentRequest.fulfilled, (state, { meta: { arg } }) => {
      state[arg.id] = { isFetching: false, success: true, error: undefined };
    });
    builder.addCase(sendPaymentRequest.rejected, (state, { meta: { arg }, error }) => {
      state[arg.id] = { isFetching: false, success: false, error: error };
    });
  },
});

export const {
  actions: { resetSingleSendPaymentRequestError, resetSingleSendPaymentRequestSuccess },
  reducer: sendPaymentRequestsActionsReducer,
} = sendPaymentRequestActionsSlice;
